import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = null as string | null;

// This is the time that the user has selected to change to
// Transient state or Buffer

// NOTE: Do not use this for delivery
const slice = createSlice({
  name: '$bufferPickupTime',
  initialState,
  reducers: {
    setBufferPickupTime(state, action: PayloadAction<string | null>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, () => {
      return initialState;
    });
  },
});

export const { setBufferPickupTime } = slice.actions;
export default slice.reducer;
